import Loadable from 'react-loadable';
import LoadingScreen from 'react-loading-screen';
import React from 'react';
import logo from './assets/img/Autopartes-del-Sur-logoNew.png';

const Loading = (props) => <LoadingScreen loading={true} spinnerColor='#9ee5f8' logoSrc={logo}><div /></LoadingScreen>;

const Articulos = Loadable({
  loader: () => import('./views/Articulos'),
  loading: Loading,
});
const Ofertas = Loadable({
  loader: () => import('./views/Ofertas'),
  loading: Loading,
});
const Perfil = Loadable({
  loader: () => import('./views/Perfil'),
  loading: Loading,
});
const Pedidos = Loadable({
  loader: () => import('./views/Pedidos'),
  loading: Loading,
});
const Login = Loadable({
  loader: () => import('./views/Login'),
  loading: Loading,
});
const ResumenCuenta = Loadable({
  loader: () => import('./views/CuentasCorrientes/'),
  loading: Loading,
});
const routes = [
  { path: '/', exact: true, name: 'Home', component: Login, logged: false },
  { path: '/login', exact: true, name: 'Login', component: Login, logged: false },
  { path: '/perfil', exact: true, name: 'Perfil', component: Perfil, logged: true },
  { path: '/resumencuenta', name: 'Resumen', component: ResumenCuenta, logged: true },
  { path: '/historialpedidos', exact: true, name: 'Pedidos', component: Pedidos, logged: true },
  { path: '/catalogo', exact: true, name: 'Articulos', component: Articulos, logged: true },
  { path: '/novedades', exact: true, name: 'Novedades', component: Ofertas, logged: true },
];
export default routes;



// WEBPACK FOOTER //
// ./src/routes.js